import { useRef, useState } from "react";

import { useSettings, useSettingsDispatch } from "../../context/SettingsProvider";
import { useUser, useUserDispatch } from "../../context/UserProvider";
import { useCommentsDispatch } from "../../context/CommentsProvider";

import { getRandomEmail, validateEmail } from "../../inc/functions";

export default function UserFormModal(){

	const settings = useSettings();
	const settingsDispatch = useSettingsDispatch();

	const userContext = useUser();
	const userDispatch = useUserDispatch();

	const commentsDispatch = useCommentsDispatch();

	const [author, setAuthor] = useState('');
	const [error, setError] = useState('');

	const email = useRef(null);
	const consent = useRef(null);

	const resetForm = () => {
		setAuthor('');
		email.current.value = '';
	}

	const onFormSubmit = (e) => {
		e.preventDefault();
		setError('');

		if(!author.trim()){
			setError('Invalid author name');
			return;
		}

		if(!email.current.value.trim() || !validateEmail(email.current.value.trim())){
			setError('Invalid email');
			return;
		}

		const user = {
			name: author.trim(),
			email: email.current.value.trim(),
			consent: null !== consent && consent.current.checked,
			type: 'commenter'
		};

		if(null !== consent && consent.current.checked){
			userDispatch({
				type: 'set',
				user: user
			});
		} else {

			if(null !== settings.deferedComment){
				commentsDispatch({type: 'addNoConsent', user: user});
			}
		}

		resetForm();
	}

	const onGuestButtonClick = (e) => {
		e.preventDefault();

		const user = {
			name: !!settings.anonymousUsername ? settings.anonymousUsername : 'Guest',
			email: getRandomEmail(),
			consent: true,
			type: 'commenter'
		};

		userDispatch({
			type: 'set',
			user: user
		});

		resetForm();
	}

	return (
		<>
		{(!settings.commentRegistration && settings.isFormExpanded && !userContext.name) &&
			<div className="login-form--modal">
				<div className="login-form--modal-wrapper">
					<button
						className="login-form--modal-close-btn"
						onClick={() => { settingsDispatch({type: 'expandForm', isFormExpanded: false}) }}
						disabled={settings.isLoading ? true : false}
					>
						<svg version="1.1" id="Capa_1" xmlns="http://www.w3.org/2000/svg" x="0px" y="0px" width="94.926px" height="94.926px" viewBox="0 0 94.926 94.926">
							<g>
								<path d="M55.931,47.463L94.306,9.09c0.826-0.827,0.826-2.167,0-2.994L88.833,0.62C88.436,0.224,87.896,0,87.335,0
									c-0.562,0-1.101,0.224-1.498,0.62L47.463,38.994L9.089,0.62c-0.795-0.795-2.202-0.794-2.995,0L0.622,6.096
									c-0.827,0.827-0.827,2.167,0,2.994l38.374,38.373L0.622,85.836c-0.827,0.827-0.827,2.167,0,2.994l5.473,5.476
									c0.397,0.396,0.936,0.62,1.498,0.62s1.1-0.224,1.497-0.62l38.374-38.374l38.374,38.374c0.397,0.396,0.937,0.62,1.498,0.62
									s1.101-0.224,1.498-0.62l5.473-5.476c0.826-0.827,0.826-2.167,0-2.994L55.931,47.463z" fill="#313131"/>
							</g>
						</svg>
					</button>
					<div className={settings.isLoading ? "login-form--container is-loading" : "login-form--container"}>
						<h1 className="login-form--heading">Post a Comment</h1>
						{error && 
							<div className="error-message">{error}</div>
						}
						<form className="login-form--form" onSubmit={onFormSubmit}>
							<label className="text-field">
								<input
									type="text"
									placeholder="Name"
									value={author}
									onChange={(e) => { setAuthor(e.target.value) }}
									disabled={settings.isLoading ? true : false}
								/>
							</label>
							<label className="text-field">
								<input
									type="email"
									placeholder="Email"
									ref={email}
									disabled={settings.isLoading ? true : false}
								/>
							</label>
							{ settings.showCommentsCookiesOptIn &&
								<label className="consent-field">
									<input
										type='checkbox'
										ref={consent}
										disabled={settings.isLoading ? true : false}
									/>
									<span>Save my name and email in this browser for the next time I comment.</span>
								</label>
							}
							<input
								type='submit'
								value={`Comment as ${!!author ? author : 'Name'}`}
								disabled={settings.isLoading ? true : false}
							/>
						</form>

						{!settings.requireNameEmail && 
							<>
								<div className="form-container--separator"><span className="separator-text">OR</span></div>

								<button
									className="login-form--guest-btn"
									onClick={onGuestButtonClick}
									disabled={settings.isLoading ? true : false}
								>Comment as {settings.anonymousUsername}</button>
							</>
						}

					</div>
				</div>
			</div>
		}
		</>
	)
}